import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'ErrorCache';

/**
 * ErrorCache — FIFO queue of error messages.
 * Extends CacheBase2 — uses _items array as the queue.
 * Errors are pushed to the back, consumed from the front.
 */
class ErrorCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }

    /**
     * Adds an error to the back of the queue.
     * @param  {*}} item error item {source, message, data  }
     */
    add(item) {
        try {
            this._check();
            this._items.push(item);
        } catch (error) {
            this.logError('add', error.message);
        }
    }

    /**
     * Returns the first error in the queue, or null if empty.
     * @returns {{ source: string, message: string }|null}
     */
    getFirst() {
        try {
            this._check();
            return this._items[0] ?? null;
        } catch (error) {
            this.logError('getFirst', error.message);
            return null;
        }
    }

    /**
     * Removes the error at the given index.
     * @param {number} index
     */
    removeAt(index) {
        try {
            this._check();
            this._items.splice(index, 1);
        } catch (error) {
            this.logError('removeAt', error.message);
        }
    }
}

const errorCache = new ErrorCache();
export default errorCache;
